import moment from 'moment';
import fieldFormatters from '../../../application/react-table/helpers/fieldFormatter';
import DATE_FORMATS from '../../../application/react-table/constants/dateFormats';

export function number(row) {
  return (typeof row.value === 'undefined' || row.value === null) ? 0 : row.value;
}

export function float(row) {
  return number(row);
}

export function boolean(row) {
  return (typeof row.value === 'undefined' || row.value === null || !row.value) ? 'No' : 'Yes';
}

export function date(row, dateFormat) {
  return (typeof row.value === 'undefined' || row.value === null) ? '' : moment(row.value).format(dateFormat);
}

export function dateWithDay(row, dateFormat) {
  return (typeof row.value === 'undefined' || row.value === null) ? '' : moment(row.value).format(DATE_FORMATS.dateWithDayName);
}

export function dateTimeWithSeconds(row, dateFormat) {
  return (typeof row.value === 'undefined' || row.value === null) ? '' : moment(row.value).format(dateFormat);
}

export function commaText(row) {
  return (typeof row.value === 'undefined' || row.value === null) ? row.value : row.value.join(',');
}

export function percentage(row) {
  const percentageValue = row.value;

  if ((!percentageValue || Number.isNaN(Number(percentageValue))) && percentageValue !== 0) {
    return row.value;
  }

  const roundedPercentageValue = (Math.round(percentageValue * 10) / 10).toFixed(1);

  return `${roundedPercentageValue} %`;
}

export const formatMap = {
  number,
  float,
  boolean,
  date,
  commaText,
  dateTimeWithSeconds,
  dateWithDay,
  percentage,
};

export default function excelFieldFormatters(fieldType) {
  return formatMap[fieldType] ? formatMap[fieldType] : fieldFormatters(fieldType);
}
